module.exports = __webpack_public_path__ + "img/users-plus.4eb6c383.svg";